import React, {
    useEffect, useState,
} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import GridItem from '../Grid/GridItem';
import Typography from '../Typography/CustomTypography';
import { clearAdvertisement, getAdvertisementRequested } from '../../actions/Home';
import { Role } from '../../common/Constants';
import styles from '../../assets/jss/pages/homePageStyle';
import ImgDialog from '../Dialog/ImgDialog';
import GridContainer from '../Grid/GridContainer';

const useStyles = makeStyles(styles);

const Advertisement = (props) => {
    const [adsArr, setAdsArr] = useState([]);
    const [isOpenAdsImage, setOpenAdsImage] = useState(false);
    const [imageHref, setImageHref] = useState('');
    const {
        adsData, role, eventInfo, fetchAds, clearAds, needSeparator, customColor, locale,
    } = props;
    const classes = useStyles();

    useEffect(() => {
        if (Number(role) !== Role.admin && Number(role) !== Role.organizer) {
            fetchAds({
                event_name: eventInfo.short_name,
                language: locale,
            });
        } else {
            clearAds();
        }
    }, [eventInfo, role, locale]);

    useEffect(() => {
        setAdsArr(adsData);
    }, [adsData]);

    const handleOpenDialogImage = (href) => {
        setOpenAdsImage(true);
        setImageHref(href);
    };

    return (
        <>
            <GridContainer style={{ marginTop: '60px' }} justify="center">
                {needSeparator && adsArr.length > 0 && (
                    <GridContainer justify="center" style={{ marginBottom: '20px' }}>
                        <GridItem xs={12}>
                            <hr />
                        </GridItem>
                    </GridContainer>
                )}
                <GridItem xs={12} lg={10}>
                    <GridContainer>
                        { adsArr.length > 0 && (
                            adsArr.map((ads) => (
                                <GridItem key={ads.id} xs={12} md={3} style={{ marginBottom: '20px', cursor: 'pointer' }} onClick={() => handleOpenDialogImage(ads.image)}>
                                    <div className={classes.adsImage} style={{ backgroundImage: `url(${ads.image})` }} />
                                    <Typography align="center" customColor={customColor?.contents_text_color}>
                                        {ads.description}
                                    </Typography>
                                </GridItem>
                            ))
                        )}
                        <ImgDialog
                            open={isOpenAdsImage}
                            handleClose={() => setOpenAdsImage(false)}
                            href={imageHref}
                        />
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </>
    );
};

Advertisement.defaultProps = {
    adsData: {},
    eventInfo: {},
    role: 1000,
    needSeparator: false,
    customColor: {},
    locale: 'ja',
};

Advertisement.propTypes = {
    adsData: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    fetchAds: PropTypes.func.isRequired,
    clearAds: PropTypes.func.isRequired,
    role: PropTypes.number,
    needSeparator: PropTypes.bool,
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,

};
const mapStateToProps = (state, ownProps) => ({
    eventInfo: state.registration.registrationViewer.data,
    adsData: state.home.getAdvertisement.data,
    role: state.auth.credential.data.role,
    needSeparator: ownProps.needSeparator,
    token: state.auth.credential.data.token,
    locale: state.locale.lang.current,
});
const mapDispatchToProps = (dispatch) => ({
    fetchAds: (event) => {
        dispatch(getAdvertisementRequested(event));
    },
    clearAds: () => {
        dispatch(clearAdvertisement());
    },
});
export default connect(mapStateToProps, mapDispatchToProps)(Advertisement);
